/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PayRunLineDto
 */
export interface PayRunLineDto {
  /**
   *
   * @type {string}
   * @memberof PayRunLineDto
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof PayRunLineDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PayRunLineDto
   */
  hours?: string | null;
  /**
   *
   * @type {string}
   * @memberof PayRunLineDto
   */
  amount?: string | null;
  /**
   *
   * @type {string}
   * @memberof PayRunLineDto
   */
  note?: string | null;
}

/**
 * Check if a given object implements the PayRunLineDto interface.
 */
export function instanceOfPayRunLineDto(value: object): value is PayRunLineDto {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function PayRunLineDtoFromJSON(json: any): PayRunLineDto {
  return PayRunLineDtoFromJSONTyped(json, false);
}

export function PayRunLineDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PayRunLineDto {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    name: json["name"],
    hours: json["hours"] == null ? undefined : json["hours"],
    amount: json["amount"] == null ? undefined : json["amount"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function PayRunLineDtoToJSON(json: any): PayRunLineDto {
  return PayRunLineDtoToJSONTyped(json, false);
}

export function PayRunLineDtoToJSONTyped(
  value?: PayRunLineDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    name: value["name"],
    hours: value["hours"],
    amount: value["amount"],
    note: value["note"],
  };
}
